import { Component, OnInit } from '@angular/core';
import { LibraryService,PlacementService } from '../../services/index';
import { HttpClient } from '@angular/common/http';
import { ChartType } from 'chart.js';
import { MultiDataSet } from 'ng2-charts';
import { ChartDataSets , RadialChartOptions } from 'chart.js';
import { SingleDataSet, Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip } from 'ng2-charts';
import {  ChartOptions } from 'chart.js';
import { Color} from 'ng2-charts';

@Component({
  selector: 'app-pladash',
  templateUrl: './pladash.component.html',
  styleUrls: ['./pladash.component.scss'],
  providers:[LibraryService,PlacementService],
})
export class PladashComponent implements OnInit {

 
    public dataset: any;
    public options: any;
    clsdate:any=[];
    catwiseissued:any=[];
    arrdeptwisecollect:any=[];
    arrsubjectwisecollect:any=[];
    arrpublisherwisecollect:any=[];
    arrsuplierwisecollect:any=[];
    arrpopcirculation:any=[]
    arraccndata:any=[];
    arractmember:any=[];
    arrcirdept:any=[];
    arrcirdate:any=[];
    arrcirmonth:any=[];
    aldept:boolean=false;


    infocnt:any={};
  
  arrinsdview:any=[];
  arrjopdview:any=[];
  
  ////pie
  
  public pieChartOptions: ChartOptions = {
    responsive: true,
    legend: {
        position: 'left',
      },
  };
  public pieChartLabels: Label[] ;
  public pieChartData: SingleDataSet ;
  public pieChartType: ChartType = 'pie';
  public pieChartLegend = true;
  public pieChartPlugins = [];
  public pieChartColors: Color[] = [
    {backgroundColor:["#FF00CC","#0033FF","#99CC00","#FF3333","#FFFF66"]},
    // {backgroundColor:["#9E120E","#FF5800","#FFB414"]},
    // {backgroundColor:["#9E120E","#FF5800","#FFB414"]}
  ];
  
  
   
  public procureChartLabels: Label[] ;
  public procureChartData: SingleDataSet ;
  public procureChartType: ChartType = 'pie';
  public procureChartLegend = true;
  public procureChartPlugins = [];
  public procureChartColors: Color[] = [
    {backgroundColor:["#FF00CC","#0033FF","#99CC00","#FF3333","#FFFF66","#5EE8C6","#5EC2E8","#AF5EE8","#5EE8A1","#9505F9","#F9A005","#F90595","#BC3210","#A5E2ED"]},
    // {backgroundColor:["#9E120E","#FF5800","#FFB414"]},
    // {backgroundColor:["#9E120E","#FF5800","#FFB414"]}
  ];
  
  
  ///barchart
  
    barChartOptions: ChartOptions = {
      responsive: true,
    };
    barChartLabels: Label[] = [];
    barChartType: ChartType = 'bar';
    barChartLegend = true;
    barChartPlugins = [];
    barChartColors: Color[] = [
      {
        
        backgroundColor: '#FF00CC',
      },
      {
       
        backgroundColor: '#0033FF',
      },
    ];
    barChartData: ChartDataSets[] = [
      // { data: [45, 37, 60, 70, 46, 33], label: 'Best Fruits' }
    ];
  
  
    walkinChartLabels: Label[] = [];
    walkinChartData: ChartDataSets[] = [
      // { data: [45, 37, 60, 70, 46, 33], label: 'Best Fruits' }
    ];
  walkinChartColors: Color[] = [
      {
        
        backgroundColor: '#F1670D',
      }
    ];
  ///linechart 
    lineChartData: ChartDataSets[];
    
    // = [
    //   { data: [85, 72, 78, 75, 77, 75], label: 'Crude oil prices', 
    //   backgroundColor: "rgba(150,150,150,50)",borderColor: "rgba(220,220,220,2)"},
    //   { data: [62, 75, 92, 68, 72, 80], label: 'Others',
    //   backgroundColor: "rgba(151,187,205,0.2)",
    //   borderColor: "rgba(151,187,205,1)" },
    // ];
  
    lineChartLabels: Label[] ;
    //= ['January', 'February', 'March', 'April', 'May', 'June'];
  
    lineChartOptions = {
      responsive: true,
    };
  
    lineChartColors: Color[] = [
      {
        borderColor: "#bbb414",
        backgroundColor: '#e4de54',
      },
      {
        borderColor: "#ff5800",
        backgroundColor: '#f3915d',
      },
    ];
  
    lineChartLegend = true;
    lineChartPlugins = [];
    lineChartType = 'line';
  
    /////bubble
   
   
  ///doughnut
  
    doughnutChartLabels: Label[] ;
    //= ['BMW', 'Ford', 'Tesla'];
    doughnutChartData: MultiDataSet ;
    // = [
    //   [55, 25, 20]
    // ];
    doughnutChartType: ChartType = 'doughnut';
    public doughnutChartColors: Color[] = [
      {backgroundColor:["#9E120E","#FF5800","#FFB414","#BBB414","#8BE212","#FF3333","#FFFF66","#5EE8C6","#5EC2E8","#AF5EE8","#5EE8A1","#9505F9","#F9A005","#F90595","#BC3210","#A5E2ED"]},
      // {backgroundColor:["#9E120E","#FF5800","#FFB414"]},
      // {backgroundColor:["#9E120E","#FF5800","#FFB414"]}
    ];
  
    chartacsnChartLabels: Label[] ;
    //= ['BMW', 'Ford', 'Tesla'];
    chartacsnChartData: MultiDataSet ;
  //old line
  
    dashcounts:any={};
    constructor(private http: HttpClient, private liservice: LibraryService,private pservice: PlacementService) {
      monkeyPatchChartJsTooltip();
      monkeyPatchChartJsLegend();
  
  
      this.dataset = [{label: 'line1', data: [[1, 130], [2, 40], [3, 80], [4, 160], [5, 159], [6, 370], [7, 330], [8, 350], [9, 370]]}];
      this.options = {
          series: {
            lines: { show: true },
            points: {
              radius: 3,
              show: true
            }
          }
        };
  
    }
  
   
  
  
    ngOnInit(): void {
      this.overview();
     
    }


    overview() {
    
      this.pservice.getpostoverview()
          .subscribe(
          resultArray => {
              console.log('bloodgp', resultArray);
              this.infocnt = resultArray.placeinfocnt;
              this.arrinsdview = resultArray.arrinsdview;
              this.arrjopdview = resultArray.arrjopdview;
  this.booksoverview(resultArray.arrdonutjob);
              
          },
          error => console.log("Error :: " + error)
          )
    }
    chartview()
    {
      this.Booksissue_received('dailybooks');
      //this.booksoverview();
      this.booksverified();
      this.catwiseisue();
      this.chartprocure();
      this.chartwalkins('chartdailywalkin');
      this.chartaccssion();
  
    }
  
    dataview()
    {
  this.deptwisecollect();
  this.subjectwisecollect();
  this.publisherwisecollect();
  this.suplierwisecollect();
  this.popcirculation();
    }
    cirview()
    {
      this.ciractivemembers();
      this.cirdate();
      this.cirdepartment();
      this.cirmonth();
    }
    deptwisecollect()
    {
        this.liservice.Getdashboarddata('collectdept')
      .subscribe(
             resultArray =>{
     // this.liservice.Getdashboarddata('dashcounts')
        console.log('result-dashcounts',resultArray) ;
        this.arrdeptwisecollect=resultArray;
  
  
        },
       error => console.log('Error :: ' + error)
    );
    }
  
    ciractivemembers()
    {
        this.liservice.Getdashboarddata('memactives')
      .subscribe(
             resultArray =>{
     // this.liservice.Getdashboarddata('dashcounts')
        console.log('result-arractmember',resultArray) ;
        this.arractmember=resultArray;
  
  
        },
       error => console.log('Error :: ' + error)
    );
    }
    cirdepartment()
    {
        this.liservice.Getdashboarddata('cirdept')
      .subscribe(
             resultArray =>{
     // this.liservice.Getdashboarddata('dashcounts')
        console.log('result-cirdept',resultArray) ;
        this.arrcirdept=resultArray;
  
  
        },
       error => console.log('Error :: ' + error)
    );
    }
    cirmonth()
    {
        this.liservice.Getdashboarddata('cirdate')
      .subscribe(
             resultArray =>{
     // this.liservice.Getdashboarddata('dashcounts')
        console.log('result-cirdate',resultArray) ;
        this.arrcirdate=resultArray;
  
  
        },
       error => console.log('Error :: ' + error)
    );
    }
  
    cirdate()
    {
        this.liservice.Getdashboarddata('cirmonth')
      .subscribe(
             resultArray =>{
     // this.liservice.Getdashboarddata('dashcounts')
        console.log('result-cirmonth',resultArray) ;
        this.arrcirmonth=resultArray;
  
  
        },
       error => console.log('Error :: ' + error)
    );
    }
  
    subjectwisecollect()
    {
        this.liservice.Getdashboarddata('collectsubj')
      .subscribe(
             resultArray =>{
     // this.liservice.Getdashboarddata('dashcounts')
        console.log('result-dashcounts',resultArray) ;
        this.arrsubjectwisecollect=resultArray;
  
  
        },
       error => console.log('Error :: ' + error)
    );
    }
    publisherwisecollect()
    {
        this.liservice.Getdashboarddata('collectpublish')
      .subscribe(
             resultArray =>{
     // this.liservice.Getdashboarddata('dashcounts')
        console.log('result-dashcounts',resultArray) ;
        this.arrpublisherwisecollect=resultArray;
  
  
        },
       error => console.log('Error :: ' + error)
    );
    }
  
    suplierwisecollect()
    {
        this.liservice.Getdashboarddata('collectsuply')
      .subscribe(
             resultArray =>{
     // this.liservice.Getdashboarddata('dashcounts')
        console.log('result-dashcounts',resultArray) ;
        this.arrsuplierwisecollect=resultArray;
  
  
        },
       error => console.log('Error :: ' + error)
    );
    }
  
    popcirculation()
    {
        this.liservice.Getdashboarddata('popularcirc')
      .subscribe(
             resultArray =>{
     // this.liservice.Getdashboarddata('dashcounts')
        console.log('result-dashcounts',resultArray) ;
        this.arrpopcirculation=resultArray;
  
  
        },
       error => console.log('Error :: ' + error)
    );
    }
    Dasheadcounts()
    {
        this.liservice.Getdashboarddata('libdashcount')
      .subscribe(
             resultArray =>{
     // this.liservice.Getdashboarddata('dashcounts')
        console.log('result-dashcounts',resultArray) ;
        this.dashcounts=resultArray[0];
  
  
        },
       error => console.log('Error :: ' + error)
    );
    }
  
    catwiseisue()
    {
        this.liservice.Getdashboarddata('catwiseissue')
      .subscribe(
             resultArray =>{
     // this.liservice.Getdashboarddata('dashcounts')
        console.log('result-catwiseissued',resultArray) ;
        this.catwiseissued=resultArray;
  
  
        },
       error => console.log('Error :: ' + error)
    );
    }
  
    chartwalkins(oprtype)
  {
    
    this.liservice.Getdashboarddata(oprtype)
    .subscribe(
      
     resultArray =>{
      console.log('result-'+oprtype,resultArray) ;
      //this.clsdate=resultArray;
      var arr = [];
      var issued = [];
      var returned = [];
      for ( var i = 0; i < resultArray.length ; i++) {
        //console.log('multiarray -i',JSON.stringify(i));
         
              
              arr.push(resultArray[i].date15);
              issued.push(parseInt( resultArray[i].issued)); // 
             // returned.push(parseInt( resultArray[i].returned));
              
             
      }
      // this.lineChartData = [
      //   { data: issued, label: 'Issued', 
      //   backgroundColor: "rgba(150,150,150,50)",borderColor: "rgba(220,220,220,2)"},
      //   { data: returned, label: 'Returned',
      //   backgroundColor: "rgba(151,187,205,0.2)",
      //   borderColor: "rgba(151,187,205,1)" },
      // ];
     this.walkinChartData = [
        { data: issued, label: 'Walkins', 
       },
        
      ];
       this.walkinChartLabels = arr;
    
     
      
      
     // this.dataSource = new MatTableDataSource(resultArray);
      },
     error => console.log("Error :: " + error)
  )
  }
    
  Booksissue_received(oprtype)
  {
    
    this.liservice.Getdashboarddata(oprtype)
    .subscribe(
      
     resultArray =>{
      console.log('Booksissue_received-'+oprtype,resultArray) ;
      //this.clsdate=resultArray;
      var arr = [];
      var issued = [];
      var returned = [];
      for ( var i = 0; i < resultArray.length ; i++) {
        //console.log('multiarray -i',JSON.stringify(i));
         
              
              arr.push(resultArray[i].date15);
              issued.push(parseInt( resultArray[i].issued)); // 
              returned.push(parseInt( resultArray[i].returned));
              
             
      }
      // this.lineChartData = [
      //   { data: issued, label: 'Issued', 
      //   backgroundColor: "rgba(150,150,150,50)",borderColor: "rgba(220,220,220,2)"},
      //   { data: returned, label: 'Returned',
      //   backgroundColor: "rgba(151,187,205,0.2)",
      //   borderColor: "rgba(151,187,205,1)" },
      // ];
     this.barChartData = [
        { data: issued, label: 'Issued', 
       },
        { data: returned, label: 'Returned',
         },
      ];
       this.barChartLabels = arr;
    
     
      
      
     // this.dataSource = new MatTableDataSource(resultArray);
      },
     error => console.log("Error :: " + error)
  )
  }
  
  booksoverview(resultArray)
  {
    
   
      console.log('result',resultArray) ;
      this.clsdate=resultArray;
  
      //this.mutitest();
     // this.dataSource = new MatTableDataSource(resultArray);
     var arr = []
     var labelarr=[];
  
  
     for ( var i = 0; i < resultArray.length ; i++) {
      //console.log('multiarray -i',JSON.stringify(i));
       
            
      labelarr.push(resultArray[i].lbl);
           
      arr.push(parseInt( this.clsdate[i].cnt));    
           
    }
      
     
      this.doughnutChartLabels = labelarr;
     this.doughnutChartData = arr;
     
    
  }
  
  chartaccssion()
  {
    
    this.liservice.Getdashboarddata('chartbookaccsion')
    .subscribe(
      
     resultArray =>{
      console.log('result',resultArray) ;
      this.arraccndata=resultArray;
  
     
    //  var arr = []
    //  var labelarr=[];
  
  
    //  for ( var i = 0; i < resultArray.length ; i++) {
    //   //console.log('multiarray -i',JSON.stringify(i));
       
            
    //   labelarr.push(resultArray[i].acsnm);
           
    //   arr.push(parseInt( resultArray[i].cnt));    
           
    // }
      
     
    //   this.chartacsnChartLabels = labelarr;
    //  this.chartacsnChartData = arr;
     
    //  console.log("doughnutChartData ", this.chartacsnChartData);
      },
     error => console.log("Error :: " + error)
  )
  }
  booksverified()
  {
    
    this.liservice.Getdashboarddata('booksverify')
    .subscribe(
      
     resultArray =>{
      console.log('result',resultArray) ;
      this.clsdate=resultArray;
  
      //this.mutitest();
     // this.dataSource = new MatTableDataSource(resultArray);
     var arr = []
     var labelarr=[];
  
  
     for ( var i = 0; i < resultArray.length ; i++) {
      //console.log('multiarray -i',JSON.stringify(i));
       
            
      labelarr.push(resultArray[i].emnm);
           
      arr.push(parseInt( resultArray[i].vcount));    
           
    }
      
     
      this.pieChartLabels = labelarr;
     this.pieChartData = arr;
     
     console.log("pieChartData ", this.pieChartLabels);
      },
     error => console.log("Error :: " + error)
  )
  }
  
  chartprocure()
  {
    
    this.liservice.Getdashboarddata('chartbookprocure')
    .subscribe(
      
     resultArray =>{
      console.log('result',resultArray) ;
      this.clsdate=resultArray;
  
      //this.mutitest();
     // this.dataSource = new MatTableDataSource(resultArray);
     var arr = []
     var labelarr=[];
  
  
     for ( var i = 0; i < resultArray.length ; i++) {
      //console.log('multiarray -i',JSON.stringify(i));
       
            
      labelarr.push(resultArray[i].srcnm);
           
      arr.push(parseInt( resultArray[i].cnt));    
           
    }
      
     
      this.procureChartLabels = labelarr;
     this.procureChartData = arr;
     
     console.log("pieChartData ", this.procureChartLabels);
      },
     error => console.log("Error :: " + error)
  )
  }
  }
